export default __webpack_public_path__ + "../staticImages/frau_beeren-260.png";